import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    //SidebarComponent
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css'
})
export class LayoutComponent implements AfterViewInit {

   constructor(private renderer: Renderer2) { }

  ngAfterViewInit(): void {
      //const scriptId = 'theme-script'; // Unique ID for tracking
      //// Check if the script is already added
      //if (document.getElementById(scriptId)) {
      //  //console.log('Script already exists, reinitializing theme functions...');      
      //  return;
      //}
      //// Dynamically add the script if not present
      //const script = this.renderer.createElement('script');
      //script.src = 'assets/theme/js/app.bundle.js';
      //script.id = scriptId; // Assign ID to avoid multiple loads
      //script.onload = () => {
      //  //console.log('Script loaded successfully');
      //};
      //this.renderer.appendChild(document.body, script);    
  }
  



}
